<div class="flex flex-col gap-md">
  <div class="flex items-center justify-between gap-md border-b border-border-ultra-light pb-sm">
    <doka-checkbox
      [label]="'Common.SelectAll' | i18nextEager"
      [checked]="allSelected()"
      [inderminate]="someSelected()"
      [disabled]="selectableIds().length === 0"
      (checkedChange)="toggleAll($event)"
      [attr.data-testid]="testIdPrefix() + '-select-all'"
    />
    <span class="text-text-ultra-light text-sm whitespace-nowrap" [attr.data-testid]="testIdPrefix() + '-selected-count'">
      {{ "Common.SelectedCount" | i18nextEager: { count: selectedIds().size } }}
    </span>
  </div>

  <div class="flex flex-col gap-md max-h-80 overflow-y-auto">
    @for (option of options(); track option.id) {
      <doka-checkbox
        [label]="option.label"
        [desc]="option.description ?? ''"
        [checked]="!!option.locked || selectedIds().has(option.id)"
        [disabled]="!!option.locked || !!option.disabled"
        (checkedChange)="toggle(option, $event)"
        [attr.data-testid]="testIdPrefix() + '-country-' + option.id"
      />
    }
  </div>
</div>
